/* Stain Away: progressive enhancement for Shopify Online Store 2.0. */
(() => {
  'use strict';
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];
  const config = JSON.parse($('#ThemeConfig')?.textContent || '{}');
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const controllers = new Map();
  let motion = document.body.dataset.motionDefault !== 'false' && !reduce.matches;
  let cartBusy = false;
  const clamp = n => Math.max(0, Math.min(1, n));
  const announce = text => { const el = $('[data-site-status]'); if (el) el.textContent = text; };
  function close(dialog) { dialog?.close(); if (!$('dialog[open]')) document.body.classList.remove('dialog-open'); }
  function open(dialog) { if (!dialog?.showModal) return false; $$('dialog[open]').forEach(close); dialog.showModal(); document.body.classList.add('dialog-open'); return true; }
  function setMotion(value) {
    motion = value && !reduce.matches;
    document.documentElement.dataset.motion = motion ? 'on' : 'off';
    $$('[data-motion-toggle]').forEach(b => { b.setAttribute('aria-pressed', String(motion)); b.textContent = motion ? config.pauseText : config.enableText; });
    document.dispatchEvent(new CustomEvent('sa:motion'));
  }
  reduce.addEventListener('change', () => setMotion(!reduce.matches && document.body.dataset.motionDefault !== 'false'));
  document.addEventListener('click', e => {
    const closer = e.target.closest('[data-close-dialog]');
    if (closer) close(closer.closest('dialog'));
    const opener = e.target.closest('[data-open-dialog]');
    if (opener) open(document.getElementById(opener.dataset.openDialog));
    if (e.target.matches('dialog') && (e.offsetX < 0 || e.offsetX > e.target.clientWidth || e.offsetY < 0 || e.offsetY > e.target.clientHeight)) close(e.target);
    const cart = e.target.closest('[data-open-cart]');
    if (cart && document.body.dataset.cartDrawerEnabled === 'true' && open($('#CartDrawer'))) e.preventDefault();
    if (e.target.closest('[data-motion-toggle]')) setMotion(!motion);
    const stickyAdd = e.target.closest('[data-sticky-add]');
    if (stickyAdd && !stickyAdd.disabled) { const form = $('.sa-product-form'); if (form) { if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true })); } }
    const stickyQtyMinus = e.target.closest('[data-sticky-qty-minus]');
    if (stickyQtyMinus) $('[data-qty-minus]', $('.sa-product-form'))?.click();
    const stickyQtyPlus = e.target.closest('[data-sticky-qty-plus]');
    if (stickyQtyPlus) $('[data-qty-plus]', $('.sa-product-form'))?.click();
    const cartQtyMinus = e.target.closest('[data-cart-qty-minus]');
    const cartQtyPlus = e.target.closest('[data-cart-qty-plus]');
    if ((cartQtyMinus && !cartQtyMinus.disabled) || (cartQtyPlus && !cartQtyPlus.disabled)) {
      const wrap = (cartQtyMinus || cartQtyPlus).closest('.quantity');
      const lineKey = wrap?.dataset.lineKey;
      const targetVariant = cartQtyMinus ? wrap?.dataset.prevVariant : wrap?.dataset.nextVariant;
      if (wrap && lineKey && targetVariant) {
        swapLineVariant(lineKey, targetVariant, cartQtyMinus || cartQtyPlus);
      } else {
        const input = $('[data-cart-quantity]', wrap);
        if (input && !input.readOnly) { if (cartQtyMinus) input.stepDown(); else input.stepUp(); input.dispatchEvent(new Event('change', { bubbles: true })); }
      }
    }
    const upsellAdd = e.target.closest('[data-upsell-add]');
    if (upsellAdd && !upsellAdd.disabled) swapLineVariant(upsellAdd.dataset.oldKey, upsellAdd.dataset.newVariant, upsellAdd);
  });
  document.addEventListener('close', () => { if (!$('dialog[open]')) document.body.classList.remove('dialog-open'); }, true);
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('in-view'); observer.unobserve(entry.target); } }), { threshold: .08 }) : null;
  function init(root = document) {
    const old = controllers.get(root); old?.abort();
    const control = new AbortController(); controllers.set(root, control);
    const on = (el, event, fn) => el?.addEventListener(event, fn, { signal: control.signal });
    $$('.reveal', root).forEach(el => { if (observer) { el.dataset.revealReady = ''; observer.observe(el); } });
    $$('[data-comparison]', root).forEach(el => {
      const range = $('input[type=range]', el);
      const paint = () => { const n = clamp(Number(range.value) / 100) * 100; $('[data-before-layer]', el).style.clipPath = `inset(0 ${100-n}% 0 0)`; $('[data-compare-divider]', el).style.left = `${n}%`; };
      on(range, 'input', paint); paint();
    });
    $$('[data-stain-tabs]', root).forEach(el => {
      const tabs = $$('[data-tab]', el), panels = $$('[data-stain-panel]', el);
      $('[data-tab-list]', el)?.setAttribute('role', 'tablist');
      const select = tab => { tabs.forEach(t => { const active = t === tab; t.setAttribute('aria-selected', active); t.tabIndex = active ? 0 : -1; t.dataset.state = active ? 'active' : 'inactive'; }); panels.forEach(p => p.hidden = p.dataset.stainPanel !== tab.dataset.tab); };
      tabs.forEach((t, i) => {
        const panel = panels.find(p => p.dataset.stainPanel === t.dataset.tab); if (!panel) return;
        t.id = `Tab-${t.dataset.tab}`; panel.id = `Panel-${t.dataset.tab}`; t.setAttribute('role','tab'); t.setAttribute('aria-controls',panel.id); panel.setAttribute('role','tabpanel'); panel.setAttribute('aria-labelledby',t.id);
        on(t,'click',e=>{e.preventDefault();select(t);}); on(t,'keydown',e=>{ let n = i; if(e.key==='ArrowRight') n=(i+1)%tabs.length; else if(e.key==='ArrowLeft') n=(i+tabs.length-1)%tabs.length; else if(e.key==='Home') n=0; else if(e.key==='End') n=tabs.length-1; else return; e.preventDefault(); select(tabs[n]); tabs[n].focus(); });
      });
      if(tabs.length) select(tabs[0]);
      on(el,'shopify:block:select',e=>{ const panel=e.target.closest('[data-stain-panel]'); const tab=tabs.find(t=>t.dataset.tab===panel?.dataset.stainPanel); if(tab) select(tab); });
    });
    $$('[data-product-section]',root).forEach(el=>{
      const panels=$$('[data-media-panel]',el);
      const media=id=>{ if(!panels.some(p=>p.dataset.mediaPanel===String(id))) return; panels.forEach(p=>{ p.hidden=p.dataset.mediaPanel!==String(id); if(p.hidden) $$('video',p).forEach(v=>v.pause()); }); $$('[data-media-target]',el).forEach(t=>t.setAttribute('aria-current',String(t.dataset.mediaTarget===String(id)))); };
      if(panels.length) media(panels[0].dataset.mediaPanel);
      $$('[data-media-target]',el).forEach(t=>on(t,'click',e=>{ e.preventDefault(); media(t.dataset.mediaTarget); }));
      const step=dir=>{ if(panels.length<2)return; const current=panels.findIndex(p=>!p.hidden); const next=(current+dir+panels.length)%panels.length; media(panels[next].dataset.mediaPanel); };
      on($('[data-gallery-prev]',el),'click',()=>step(-1));
      on($('[data-gallery-next]',el),'click',()=>step(1));
      const form=$('form.sa-product-form',el); if(!form)return;
      const quantity=$('[name=quantity]',form), add=$('[data-add-to-cart]',form), buyNowBtn=$('[data-buy-now]',form);
      const syncQty=()=>{ $$('[data-sticky-qty]').forEach(n=>n.textContent=quantity.value); };
      function variant(){ const v=$('[data-variant]:checked',form); if(!v)return; $$('[data-variant]',form).forEach(r=>r.closest('.pack-option').classList.toggle('selected',r===v)); add.disabled=v.disabled; if(buyNowBtn)buyNowBtn.disabled=v.disabled; $('[data-add-label]',form).textContent=v.disabled?config.soldOutText:config.addText; quantity.min=v.dataset.min||'1'; quantity.step=v.dataset.step||'1'; if(v.dataset.max)quantity.max=v.dataset.max; else quantity.removeAttribute('max'); quantity.value=quantity.min; media(v.dataset.media); $$('[data-sticky-price]').forEach(n=>n.textContent=v.dataset.price); $$('[data-sticky-tier]').forEach(n=>n.textContent=v.dataset.tier); $$('[data-sticky-add]').forEach(b=>b.disabled=v.disabled); syncQty(); }
      $$('[data-variant]',form).forEach(v=>on(v,'change',variant));
      on($('[data-qty-minus]',form),'click',()=>{ quantity.stepDown(); quantity.dispatchEvent(new Event('change',{bubbles:true})); });
      on($('[data-qty-plus]',form),'click',()=>{ quantity.stepUp(); quantity.dispatchEvent(new Event('change',{bubbles:true})); });
      on(quantity,'input',syncQty); on(quantity,'change',syncQty);
      on(form,'submit',async e=>{
        if(document.body.dataset.cartDrawerEnabled!=='true'||!$('#CartDrawer')||!window.fetch)return;
        e.preventDefault(); if(cartBusy||add.disabled)return;
        const buyNow=Boolean(e.submitter&&e.submitter.hasAttribute('data-buy-now'));
        attentionStopped=true;
        const error=$('[data-product-error]',form); error.hidden=true; cartBusy=true;
        add.disabled=true; add.setAttribute('aria-busy','true');
        if(buyNowBtn){ buyNowBtn.disabled=true; buyNowBtn.setAttribute('aria-busy','true'); }
        $$('[data-sticky-add]').forEach(b=>{ b.disabled=true; b.setAttribute('aria-busy','true'); });
        let committed=false;
        try {
          const data=new FormData(form); data.append('sections','sa-cart-drawer'); data.append('sections_url',location.pathname);
          const response=await fetch(config.cartAdd,{method:'POST',headers:{Accept:'application/json'},body:data});
          const result=await response.json(); if(!response.ok)throw new Error(result.description||result.message||config.errorText);
          committed=true;
          if(buyNow){ location.assign(config.checkoutUrl); return; }
          if(!replaceCart(result.sections?.['sa-cart-drawer'],true)) { location.assign(config.cartUrl); return; }
          announce(config.addedText);
        }catch(err){ if(committed){location.assign(config.cartUrl);return;} error.textContent=err.message||config.errorText; error.hidden=false; }
        finally{
          cartBusy=false;
          const stillDisabled=Boolean($('[data-variant]:checked',form)?.disabled);
          add.disabled=stillDisabled; add.removeAttribute('aria-busy');
          if(buyNowBtn){ buyNowBtn.disabled=stillDisabled; buyNowBtn.removeAttribute('aria-busy'); }
          $$('[data-sticky-add]').forEach(b=>{ b.disabled=stillDisabled; b.removeAttribute('aria-busy'); });
        }
      });
      const anchor=$('[data-product-anchor]',el), stickyBar=$('[data-sticky-cart]');
      if(anchor&&stickyBar&&'IntersectionObserver' in window){
        let shaken=false;
        const cartIO=new IntersectionObserver(([entry])=>{
          const pastAnchor=!entry.isIntersecting&&entry.boundingClientRect.top<0;
          stickyBar.classList.toggle('is-visible',pastAnchor);
          if(pastAnchor&&!shaken&&motion){
            const btn=$('[data-sticky-add]',stickyBar)||$('.button',stickyBar);
            if(btn){ btn.classList.add('shake'); on(btn,'animationend',()=>btn.classList.remove('shake')); }
            shaken=true;
          }
        },{threshold:0});
        cartIO.observe(anchor);
        control.signal.addEventListener('abort',()=>cartIO.disconnect(),{once:true});
      }
      let attentionStopped=false;
      const shakeButton=btn=>{ if(!btn||btn.disabled||btn.classList.contains('shake'))return; btn.classList.add('shake'); on(btn,'animationend',()=>btn.classList.remove('shake'),{once:true}); };
      const attentionTimer=setInterval(()=>{
        if(attentionStopped||!motion||document.hidden)return;
        if(stickyBar&&stickyBar.classList.contains('is-visible')) shakeButton($('[data-sticky-add]',stickyBar));
        else if(!document.body.contains(add))attentionStopped=true;
        else shakeButton(add);
      },5000);
      control.signal.addEventListener('abort',()=>clearInterval(attentionTimer),{once:true});
    });
    $$('[data-transformation]',root).forEach(el=>{
      let frame=0,playing=false,progress=0,started=0,lastScroll=0;
      const steps=$$('[data-step]',el),copies=$$('[data-stage-copy]',el),play=$('[data-demo-play]',el),video=$('[data-demo-video]',el);
      const editor=Boolean(window.Shopify?.designMode);
      const duration=Math.max(4,Number(el.dataset.duration)||7)*1000;
      function paint(p){
        progress=clamp(p); const i=Math.min(steps.length-1,Math.floor(progress*steps.length));
        copies.forEach((c,n)=>c.hidden=n!==i); steps.forEach((b,n)=>{b.classList.toggle('active',n===i);if(n===i)b.setAttribute('aria-current','step');else b.removeAttribute('aria-current');});
        const number=String(i+1).padStart(2,'0');
        $('[data-step-number]',el).textContent=number; $('[data-step-counter]',el).textContent=`${number} / ${String(steps.length).padStart(2,'0')}`;
        $('[data-stage-label]',el).textContent=steps[i]?.children[1]?.textContent||'';
        $('[data-demo-progress]',el).style.width=`${progress*100}%`;
        $('[data-stain-layer]',el).style.opacity=String(1-clamp((progress-.65)/.3));
        $('[data-hands-layer]',el).style.opacity=String(clamp((progress-.4)*10)*(1-clamp((progress-.68)*10)));
        $('[data-apply-callout]',el).classList.toggle('visible',progress>.25&&progress<.43&&!video);
        if(video&&Number.isFinite(video.duration)&&video.duration>0&&!video.seeking)video.currentTime=progress*Math.max(0,video.duration-.05);
      }
      function stop(){playing=false;cancelAnimationFrame(frame);if(play){$('span',play).textContent=play.dataset.playLabel;play.setAttribute('aria-pressed','false');}}
      function tick(now){if(!playing)return;paint((now-started)/duration);if(progress>=1)stop();else frame=requestAnimationFrame(tick);}
      function mode(){stop();el.classList.toggle('still',!motion||el.dataset.scroll!=='true'||editor);}
      function scroll(){if(!motion||editor||el.dataset.scroll!=='true')return;const top=el.getBoundingClientRect().top;const range=el.offsetHeight-innerHeight; const p=clamp(-top/Math.max(1,range)); if(Math.abs(p-lastScroll)>.002){stop();paint(p);lastScroll=p;}}
      steps.forEach((b,i)=>on(b,'click',()=>{stop();paint(steps.length>1?i/(steps.length-1):0);}));
      on(play,'click',()=>{if(playing){stop();return;}playing=true;started=performance.now()-(progress>=.99?0:progress*duration);$('span',play).textContent=play.dataset.pauseLabel;play.setAttribute('aria-pressed','true');frame=requestAnimationFrame(tick);});
      on(window,'scroll',scroll);on(window,'resize',scroll);on(document,'sa:motion',mode);
      on(el,'shopify:block:select',e=>{const copy=e.target.closest('[data-stage-copy]');if(copy){stop();paint(Number(copy.dataset.stageCopy)/Math.max(1,steps.length-1));}});
      on(video,'loadedmetadata',()=>paint(progress));
      control.signal.addEventListener('abort',stop,{once:true});
      mode();paint(0);
    });
    setMotion(motion);
  }
  function updateCartCount(itemCount){ if(itemCount!=null) $$('[data-cart-count]').forEach(el=>el.textContent=itemCount); }
  function refreshDrawer(html,show){
    if(!html)return false;
    const doc=new DOMParser().parseFromString(html,'text/html'), next=$('[data-cart-drawer]',doc), old=$('[data-cart-drawer]');
    if(!next||!old)return false;
    updateCartCount(next.dataset.itemCount);
    if(old.open)close(old);
    old.replaceWith(next);
    if(show)open(next);
    return true;
  }
  function cartPageSectionId(){
    const el=$('.cart-page')?.closest('.shopify-section');
    return el?el.id.replace(/^shopify-section-/,''):null;
  }
  function refreshCartPage(html,sectionId){
    if(!html)return false;
    const doc=new DOMParser().parseFromString(html,'text/html'), next=$('.cart-page',doc), old=$('.cart-page');
    if(!next||!old)return false;
    old.replaceWith(next);
    return true;
  }
  function replaceCart(html,show){ return refreshDrawer(html,show); }
  async function changeCart(input,remove=false){
    if(cartBusy)return;
    const drawerEl=input.closest('[data-cart-drawer]');
    const pageSectionId=cartPageSectionId();
    const surfaceEl=drawerEl||$('.cart-page-form');
    if(!surfaceEl)return;
    const n=remove?0:Number(input.value); if(!Number.isInteger(n)||n<0){input.reportValidity();return;}
    cartBusy=true; surfaceEl.setAttribute('aria-busy','true');
    const drawerError=drawerEl?$('[data-cart-error]',drawerEl):null;
    if(drawerError)drawerError.hidden=true;
    if(drawerEl)$$('button[name=checkout]',drawerEl).forEach(b=>b.disabled=true);
    const sectionsNeeded=['sa-cart-drawer']; if(pageSectionId)sectionsNeeded.push(pageSectionId);
    try{
      const response=await fetch(config.cartChange,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:input.dataset.lineKey,quantity:n,sections:sectionsNeeded,sections_url:location.pathname})});
      const result=await response.json(); if(!response.ok)throw new Error(result.description||result.message||config.errorText);
      let ok=false;
      if(result.sections?.['sa-cart-drawer'])ok=refreshDrawer(result.sections['sa-cart-drawer'],Boolean(drawerEl))||ok;
      if(pageSectionId&&result.sections?.[pageSectionId])ok=refreshCartPage(result.sections[pageSectionId])||ok;
      if(!ok)location.assign(config.cartUrl);
    }catch(err){ if(drawerError){drawerError.textContent=err.message||config.errorText;drawerError.hidden=false;} else location.assign(config.cartUrl); }
    finally{cartBusy=false;surfaceEl.removeAttribute('aria-busy');if(drawerEl)$$('button[name=checkout]',drawerEl).forEach(b=>b.disabled=false);}
  }
  async function swapLineVariant(oldKey,newVariantId,triggerEl){
    if(cartBusy||!oldKey||!newVariantId)return;
    const drawerEl=triggerEl?triggerEl.closest('[data-cart-drawer]'):$('[data-cart-drawer][open]');
    const pageSectionId=cartPageSectionId();
    cartBusy=true; if(triggerEl)triggerEl.disabled=true;
    const sectionsNeeded=['sa-cart-drawer']; if(pageSectionId)sectionsNeeded.push(pageSectionId);
    try{
      const changeRes=await fetch(config.cartChange,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:oldKey,quantity:0})});
      if(!changeRes.ok)throw new Error(config.errorText);
      const data=new FormData(); data.append('id',newVariantId); data.append('quantity','1'); data.append('sections',sectionsNeeded.join(',')); data.append('sections_url',location.pathname);
      const addRes=await fetch(config.cartAdd,{method:'POST',headers:{Accept:'application/json'},body:data});
      const result=await addRes.json(); if(!addRes.ok)throw new Error(result.description||result.message||config.errorText);
      let ok=false;
      if(result.sections?.['sa-cart-drawer'])ok=refreshDrawer(result.sections['sa-cart-drawer'],Boolean(drawerEl))||ok;
      if(pageSectionId&&result.sections?.[pageSectionId])ok=refreshCartPage(result.sections[pageSectionId])||ok;
      if(ok)announce(config.addedText); else location.assign(config.cartUrl);
    }catch(err){location.assign(config.cartUrl);}
    finally{cartBusy=false;}
  }
  document.addEventListener('change',e=>{if(e.target.matches('[data-cart-quantity]')&&!e.target.readOnly&&(e.target.closest('[data-cart-drawer]')||e.target.closest('.cart-page-form')))changeCart(e.target);});
  document.addEventListener('click',e=>{const remove=e.target.closest('[data-remove-line]');if(remove&&(remove.closest('[data-cart-drawer]')||remove.closest('.cart-page-form'))){e.preventDefault();changeCart(remove,true);}});
  document.addEventListener('submit',e=>{if(cartBusy&&(e.target.closest('[data-cart-drawer]')||e.target.matches('.cart-page-form')))e.preventDefault();});
  document.addEventListener('shopify:section:load',e=>init(e.target));
  document.addEventListener('shopify:section:unload',e=>{controllers.get(e.target)?.abort();controllers.delete(e.target);$$('.reveal',e.target).forEach(el=>observer?.unobserve(el));});
  document.addEventListener('shopify:section:select',e=>{if($('[data-cart-drawer]',e.target))open($('#CartDrawer'));});
  $$('.shopify-section').forEach(section=>init(section));
})();

/* Footer card-reveal: keep --footer-h in sync with the footer's real height so
   the desktop reveal spacer (see stain-away.css) never over- or under-shoots. */
(() => {
  const root = document.documentElement;
  let ro = null;
  function attach() {
    const footer = document.querySelector('.site-footer');
    if (!footer) return;
    if (ro) ro.disconnect();
    if ('ResizeObserver' in window) {
      ro = new ResizeObserver(entries => {
        root.style.setProperty('--footer-h', Math.ceil(entries[0].contentRect.height) + 'px');
      });
      ro.observe(footer);
    } else {
      root.style.setProperty('--footer-h', footer.offsetHeight + 'px');
    }
  }
  attach();
  window.addEventListener('resize', () => { if (!('ResizeObserver' in window)) attach(); });
  document.addEventListener('shopify:section:load', e => {
    if (e.target && e.target.querySelector && e.target.querySelector('.site-footer')) attach();
  });
})();
